import dayjs from 'dayjs'
import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { SubmitHandler } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { TreinamentoInput, treinamentoSchema, treinamentos } from 'service/api'
import { toast } from 'sonner'
import { useTreinamentosOutletContext } from 'templates/Admin/Clientes/atoms/Pages/Cobrancas'
import FormTreinamento from '../../forms/FormTreinamento'

export default function AdicionarTreinamento() {
    const navigate = useNavigate()
    const { clienteId } = useTreinamentosOutletContext()

    const { mutate, isLoading } = treinamentos.mutations.useCreate({
        invalidateQuery: true,
        queryParams: { clienteId: String(clienteId) },
    })

    const handleClose = () => navigate(-1)

    const handleSubmit: SubmitHandler<TreinamentoInput> = ({
        Tecnico,
        data,
        observacao,
        quemRecebeu,
        cobranca,
    }) => {
        mutate(
            {
                clienteId,
                data: dayjs(data).toISOString(),
                quemRecebeu,
                usuarioId: Tecnico.id,
                observacao: observacao || null,
                cobranca,
            },
            {
                onSuccess: () => {
                    toast.success('Treinamento cadastrado com sucesso!')
                    handleClose()
                },
                onError: () => {
                    toast.error('Erro ao cadastrar o treinamento!')
                },
            },
        )
    }

    return (
        <Dialog.Root
            open={hasPermission(['create', 'Treinamentos'])}
            height="fit-content"
            width="40rem"
            loading={isLoading}
            onSubmit={handleSubmit}
            schema={treinamentoSchema}
            defaultValues={{ data: dayjs().format('YYYY-MM-DDTHH:mm') }}
        >
            <Dialog.Title>Cadastrar treinamento</Dialog.Title>
            <Dialog.Content dividers>
                <FormTreinamento />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
